<template>
  <b-row id="security-data" class="section-invert reverse-sm">
    <b-col md="12" lg="6">
      <div class="col-bg ml-lg-auto">
      </div>
    </b-col>
    <b-col md="12" lg="6" class="content my-auto">
      <h3 style="font-weight:bold">{{ $t('abogalitypro.security-privacity.blackTitle') }}</h3>
      <h3 style="font-size:30px">{{ $t('abogalitypro.security-privacity.title') }}</h3>
      <div class="subtitle">
        <p>{{ $t('abogalitypro.security-privacity.text') }}</p>
      </div>
      <div class="subtitle">
        <p>{{ $t('abogalitypro.security-privacity.text2') }}</p>
      </div>
      <b-row style="display:inline-block" class="cert-icons mt-5">

        <div class="mr-5" style="display:inline-block">
					<ISO27001Logo/>
        </div>
        <div style="display:inline-block">
          <img class="vertical" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png" />
        </div>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import ISO27001Logo from '@/components/utils/ISO27001Logo.vue'

export default {
	components: {
		ISO27001Logo
	}
}
</script>

<style lang="scss" scoped>
#security-data {
  h3 {
    @include mobile(){
      font-size: 25px !important;
    }
  }

  .col-bg {
    background-blend-mode: overlay;
    background-image: url('/static-appopensalud/img/bgs/opt/privacity.jpg');
    @include mobile {
      display: none;
    }
    @include tablets {
      display: none;
    }
  }
}

/deep/.cert-icons {
  div {
    margin: {
      top: auto;
      bottom: auto;
    }

    @include desktop {
      margin-right: 5rem;
    }

    @include media(tablets, mobile) {
      padding: {
        top: 1rem;
        bottom: 1rem;
      }
    }

    display: flex;
    img {
      margin: auto;
      float: left;
      &.vertical {
        height: 120px;
        @include mobile {
          height: 100px;
        }
      }
      &:not(.vertical) {
        width: 120px;
        @include mobile {
          width: 100px;
        }
      }

      object-fit: cover;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/views/abogalitypro/AbogalitySecurityPrivacityBlock.vue